// extracted by mini-css-extract-plugin
export default {"buttons_wrap":"ViewerButtons_buttons_wrap__axto+","buttons_subwrap":"ViewerButtons_buttons_subwrap__j5cbX"};